import React from "react";
import { Link } from "react-router-dom";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p><b>{props.data ? props.data.subtitle : "Loading"}</b></p>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                {props.data && (props.data.page == true) ?
                <Link to="/register" className="btn btn-custom btn-lg page-scroll">
                  Register Now
                </Link>
                : <a href="https://hackerrank.com" className="btn btn-custom btn-lg page-scroll">Start Coding</a>} 
                {/* <a href="https://forms.gle/VmMA9b5Zp77jkp329" className="btn btn-custom btn-lg page-scroll">Register Now</a> */}
                {" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
